module.exports = __webpack_public_path__ + "static/media/niagara.e9098e7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/client_logos/niagara.png
// module id = 284
// module chunks = 0